import constate from "constate";
import { useCallback, useState } from "react";

function useAppRemountState() {
  const [remountKey, setRemountKey] = useState(0);

  const triggerRemount = useCallback(() => {
    setRemountKey((previousKey) => previousKey + 1);
  }, []);

  return {
    remountKey,
    triggerRemount,
  };
}

export const [AppRemountProvider, useAppRemount] = constate(useAppRemountState);
